// extracted by mini-css-extract-plugin
export default {"h":"styles_h__0otjX","p":"styles_p__cYcV-"};